/**
 * @prettier
 * @flow
 */
import { KEY_NAME } from 'src/localStorage/getAccountIdInLocalStorage';
import type { AccountId } from 'src/types/Id';

export function setAccountIdInLocalStorage(value: AccountId | void): void {
    if (value === undefined) {
        window.localStorage.removeItem(KEY_NAME);
        return;
    }
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value));
}
